module.exports = __webpack_public_path__ + "img/Maxima.cb1d40ea.jpg";